var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5287 3.52858C16.2683 3.78892 16.2683 4.21103 16.5287 4.47138L20.0573 7.99998L16.5287 11.5286C16.2683 11.7889 16.2683 12.211 16.5287 12.4714C16.789 12.7317 17.2111 12.7317 17.4715 12.4714L21.4715 8.47138C21.7318 8.21103 21.7318 7.78892 21.4715 7.52858L17.4715 3.52858C17.2111 3.26823 16.789 3.26823 16.5287 3.52858Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52868 3.52858C5.26833 3.78892 5.26833 4.21103 5.52868 4.47138L9.05727 7.99998L5.52868 11.5286C5.26833 11.7889 5.26833 12.211 5.52868 12.4714C5.78903 12.7317 6.21114 12.7317 6.47149 12.4714L10.4715 8.47138C10.7318 8.21103 10.7318 7.78892 10.4715 7.52858L6.47149 3.52858C6.21114 3.26823 5.78903 3.26823 5.52868 3.52858Z",
    fill: "#111827"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.316987e1deca660184fd0829711cbcfd.svg";
export { ForwardRef as ReactComponent };